import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../../reducers';
import { Api } from '../../../typings/api';
import DriveItemInfoButton from '../../../containers/DriveItem/InfoButton';
import DriveItemFavoriteIcon from '../../../containers/Favorites/favoriteIcon';
import { OfflineManagerState } from '../../../containers/OfflineManager/reducer';
import Utils from '../../../utils';
import DriveItemUtils, { ResolutionDisplayType } from '../../../utils/driveItem';
import { StyledDriveItemRow, BackgroundImage, SvgWrapper, ItemInfos, ItemLabel, ImageWrapper } from './styles';

interface DriveItemRowProps {
	dispatch: Dispatch<StoreState>;
	driveItem: Api.DriveItem;
	resolutions: { [k: string]: Api.ResolutionGroup };
	galleryConfig: Api.Config;
	offlineManager: OfflineManagerState;
}

const DriveItemRow = (props: DriveItemRowProps) => {

	const getImgElement = () => {
		const { driveItem, offlineManager, galleryConfig, resolutions, dispatch } = props;
		const favElement = <DriveItemFavoriteIcon itemId={driveItem.id} displayMode={ResolutionDisplayType.Card} />;
		const thumbnailDescriptor = DriveItemUtils.getThumbnailDescriptor(driveItem, false, offlineManager, galleryConfig, resolutions, dispatch);
		const { isImage, src } = thumbnailDescriptor;

		if (isImage) {
			return <ImageWrapper><BackgroundImage src={src} />{favElement}</ImageWrapper>;
		} else {
			return <SvgWrapper>{Utils.getSvgIcon(src)}{favElement}</SvgWrapper>;
		}
	};

	const { driveItem } = props;
	const label = DriveItemUtils.getLabel(driveItem);
	const imgElement = getImgElement();

	return (
		<StyledDriveItemRow>
			{imgElement}
			<ItemInfos>
				<ItemLabel>{label}</ItemLabel>
				<DriveItemInfoButton driveItem={driveItem} />
			</ItemInfos>
		</StyledDriveItemRow>
	);
};

export default DriveItemRow;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItem/Row/index.tsx